import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import router from '@/router/index.js'
import { getToken } from '@/utils/auth'
import Cookies from 'js-cookie'
import { setCookie, getCookie, delCookie } from './cookies.js'

// create an axios instance
const service = axios.create({
  baseURL: 'https://www.zlywh.com/admin',
  // baseURL: 'http://localhost:8000/admin',
  // baseURL: '/api',
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    console.log(config)
    // const cookie = document.cookie
    // config.headers.cookie = cookie
    if (store.getters.token) {
      // Cookies.set('Cookie', 'laravel_session=eyJpdiI6Ik5HZ0lBUDJBNzFDNTFGV291bHBrd0E9PSIsInZhbHVlIjoicjFsejlKQ09QRlRiRkZwcU1FeEhBWkRxdWRkb1k2MTk4TGZ1Ukc5dEluVWJTSG5KTm56Rm91VWJoMDhpdUhEb0s0QWVZQ1krWTEyXC96a1IySGJhWkxBbVg0XC9Td0M1RktkczJPb0FCYlNiSGRCclh4aStxSDhLbjd3ejNOU1dObSIsIm1hYyI6IjVjODQ5YmRlZmIzMjYyMTg1MTQ5ODg2NzkxOTY1MDY0MzFjOTQyYzNkNGI0MjZmYjg3MTNmOTM0ZmYzN2I4N2EifQ%3D%3D', { expires: 7 });
      // config.headers.Cookie = Cookies.get('Cookie')
    }
    return config
  },
  (error) => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response.data
    console.log('res==>', res)
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 1 && res.code !== 0) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 302 || res.code === 50012 || res.code === 50014 || typeof res === 'string') {
        // to re-login
        MessageBox.confirm(
          '您已退出登录。您可以选择取消操作以留在当前页面，或者重新登录。',
          '确认登出',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(async() => {
          await store.dispatch('user/logout')
          console.log(router.currentRoute.fullPath, 'router.currentRoute.fullPat')
          router.push(
            `/login?redirect=${router.currentRoute.fullPath}`
          )
        })
      }
      // store.dispatch('user/logout').then(() => {
      //   location.reload()
      // })

      // return Promise.reject(new Error(res.message || 'Error'))
    } else {
      // store.dispatch('user/resetToken').then(() => {
      //   location.reload()
      // })
      return res
    }
  },
  (error) => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
